/* eslint-disable react-hooks/exhaustive-deps */
import { useState,useEffect } from "react";
import {connect} from "react-redux";
import axios from "axios";

const User_Button = (props) => {
    const [message,setMessage] = useState("Follow");
    const {id,user} = props;
    useEffect(() => {
        // const updateFollow = setInterval(() => {
            checkFollow(user.id,id);
            console.log(user.id,id);
        // }, 3000);
        // return () => clearInterval(updateFollow);
    });
    const checkFollow = async(follower_id,following_id) => {
        try {
            const response = await axios.post("/follow/check",{
                follower_id,
                following_id
            },{
                withCredentials:true,
                headers:{
                    "Content-Type":"application/json"
                }
            });
            if (response.data) {
                setMessage("Unfollow")
            } else {
                setMessage("Follow")
            }
        } catch (error) {
            console.log(error);
        }
    }
    const handleClick = async() => {
        try {
            const response = await axios.post("/follow",{
                follower_id:user.id,
                following_id:id
            },{
                withCredentials:true,
                headers:{
                    "Content-Type":"application/json"
                }
            });
            setMessage(response.data.msg);
        } catch (error) {
            console.log(error);
        }
    }
    return(
        <button className={`user_follow customizecolorchange_hover customizecolorchange_${props.color_button}`} onClick={() => handleClick()}>{message}</button>
    )
}

const mapStateToProps = (state) => {
    return {
        color_button: state.getColorButton.color_button,
        user: state.getUser.user
    }
}
export default connect(mapStateToProps)(User_Button);